export const ACI_API = `${import.meta.env.VITE_API_HOST}/aci/api`
export const BASE_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-unify/api`
export const COMMON_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-unify/api/common`
export const MPCI_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-unify/api/mpci`
export const AFR_API = `${import.meta.env.VITE_API_HOST}/afr`
export const OVERSEAS_API = `${import.meta.env.VITE_API_HOST}/overseas-manifest-common/api`
export const CONST_NAS_URL = `https:${import.meta.env.VITE_NAS_URL}/pass/proxy`
export const CONST_NAS_UPLOAD_URL = `https:${import.meta.env.VITE_NAS_URL}/whale/upload/v1`

export enum ManifestAction {
  NEW = 'new',
  COPY = 'copy',
  EDIT = 'edit',
  VIEW = 'view',
  RESEND = 'resend',
  HISTORY = 'history',
  HISTORY_DETAIL = 'historyDetail',
  AI = 'ai',
}

export enum BillTypePage {
  Detail = 'Detail',
}

export enum ManifestPageType {
  DRAFT_PAGE = 'DRAFT_PAGE',
  SEND_PAGE = 'SEND_PAGE',
}

/** 五字码类型 */
export enum FiveCodeType {
  /** 五字码 */
  UN_CODE = 'UN_CODE',
  /** 自定义 */
  CUSTOM = 'CUSTOM',
}

/** 运输方式 */
export enum MovementType {
  IMPORT = 'Import',
  TRANSIT = 'Transit',
  TRANSSHIPMENT = 'Transshipment',
  FROB = 'Frob',
}

/** 申报层级，与 To Order 的 billType 无关 */
export enum BillLevel {
  HOUSE = 'HOUSE',
  MASTER = 'MASTER',
}

/** 提单类型 */
export enum BillType {
  HBL = 'HBL',
  MBL = 'MBL',
  EMPTY = '',
}

/** 温度单位 */
export enum TemperatureUnit {
  /** 摄氏度 */
  CELSIUS = 'C',
  /** 华氏度 */
  FAHRENHEIT = 'F',
}

export const IS_GLOBAL = import.meta.env.VITE_IS_GLOBAL === 'true'

// 导出party类型常量
export {
  PARTY_TYPES,
  PARTY_TYPE_LABELS,
  PARTY_TYPE_OPTIONS,
} from './party-types'

// To Order NEG:选中,NON:未选中
export enum ToOrder {
  /** 选中 */
  NEG = 'NEG',
  /** 未选中 */
  NON = 'NON',
}

/** 动态表单代码 */
export enum DYNAMIC_TABLE_CODE {
  /** 草稿列表 */
  DRAFT = 'mpci_draft_list',
  /** 已发送列表 */
  SEND = 'mpci_send_list',
  MASTER_DRAFT = 'mpci_master_draft_list',
  MASTER_SEND = 'mpci_master_send_list',
  /** 消费列表*/
  CONSUME = 'mpci_consume_list',
  /** 国际站消费记录 */
  GLOBAL_CONSUME = 'mpci_global_consume_list',
}
